import React from 'react';
import { FormattedMessage, useIntl } from "gatsby-plugin-intl";
import {TitleContainer } from '../title/styles'

const Title = ({color, messageid}) => {
  const intl = useIntl();
  const artTitle = intl.formatMessage({ id: `${messageid}`});
  return(
    <TitleContainer className="title" color={color}><FormattedMessage id={`${messageid}`} defaultMessage={artTitle} values={{span: str => <span>{str}</span>}} /></TitleContainer>
  )
}

export default Title;
